export default {
  path: '/2019PAJS',
  name: '2019PAJS',
  component: () => import('./Home.vue'),
  redirect: '/2019PAJS/Activities',
  meta: {
    title: '“一路有你·平安建设”热心市民评选活动',
  },
  children: [
    {
      path: 'Activities',
      component: () => import('./Activities.vue'),
      name: '2019PAJS/Activities',
      meta: {
        title: '“一路有你·平安建设”热心市民评选活动',
      },
    },
    {
      path: 'RelativeNews',
      component: () => import('./RelativeNews.vue'),
      name: '2019PAJS/RelativeNews',
      meta: {
        title: '“一路有你·平安建设”热心市民评选活动',
      },
    },
    {
      path: 'Video',
      component: () => import('./Video.vue'),
      name: '2019PAJS/Video',
      meta: {
        title: '“一路有你·平安建设”热心市民评选活动',
      },
    },

    {
      path: 'List',
      component: () => import('./List.vue'),
      name: '2019PAJS/List',
      meta: {
        title: '“一路有你·平安建设”热心市民评选活动',
      },
    },

    {
      path: 'DetailPage',
      component: () => import('./DetailPage.vue'),
      name: '2019PAJS/DetailPage',
      meta: {
        title: '“一路有你·平安建设”热心市民评选活动',
      },
    },
  ],
};
